module.exports = __webpack_public_path__ + "html/workflow-table.template.html";